.foldable-tree-view .selected-node {
  background-color: #e0f0ff;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;
}
.foldable-tree-view .selected-node .selected-text {
  color: #36f;
  font-weight: 500;
}
.foldable-tree-view .tree {
  list-style: none;
  margin: 0;
  padding: 20px;
}
.foldable-tree-view .tree-node,
.foldable-tree-view .tree-node-group {
  list-style: none;
  margin: 0;
  padding: 0;
}
.foldable-tree-view .tree-branch-wrapper,
.foldable-tree-view .tree-node__leaf {
  outline: none;
}
.foldable-tree-view .tree-node--focused .name {
  background-color: gray;
  font-weight: 900;
  color: #fff;
}
.foldable-tree-view .tree-node__branch {
  display: block;
}
.foldable-tree-view .tree-node__branch .name {
  padding: 2px;
}
.foldable-tree-view .tree-node {
  cursor: pointer;
  outline: none;
  padding: 2px 0;
}
.foldable-tree-view .tree-leaf-list-item .tree-node {
  cursor: default;
}
.foldable-tree-view .tree-node__leaf {
  margin-left: 25px;
}
.foldable-tree-view .tree-node .avt-react-components--icon {
  display: inline-block;
  position: relative;
}
.foldable-tree-view .tree-node .avt-react-components--icon .arrow {
  position: absolute;
  margin-top: 2px;
}
.foldable-tree-view .name {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.foldable-tree-view .arrow-container {
  margin-right: 4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */